import React from 'react';
import styled from 'styled-components';
import { theme } from 'kb-shared';

import { YellowButton } from '../../Buttons';
import { CalcType } from './CalculatorsWidget';

interface Props {
  options: CalcType[];
  selected: CalcType;
  onSelect: Function;
}

const SegmentedControl = ({ options, selected, onSelect }: Props) => (
  <Wrapper>
    {options.map(option => (
      <Button
        key={`calculators-segment-control-${option}`}
        onClick={() => onSelect(option)}
        isActive={option === selected}
      >
        {option}
      </Button>
    ))}
  </Wrapper>
);

export default SegmentedControl;

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  grid-gap: 2px;
`;

interface ButtonProps {
  readonly isActive: boolean;
}

const Button = styled(YellowButton)<ButtonProps>`
  ${theme.fonts.FoundersGrotesk};
  font-size: 14px;
  border-radius: 0;
  background-color: ${({ theme, ...props }) =>
    props.isActive ? theme.colors.yellow : theme.colors.beigeLight};
  border-color: ${({ theme, ...props }) =>
    props.isActive ? theme.colors.yellow : theme.colors.beigeLight};
  white-space: nowrap;
`;
